export const euro = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export const euro2 = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(n || 0);

export const shortDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short" });
};

export const longDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "long", year: "numeric" });
};

export const timeOnly = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
};

export const dayName = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString("es-ES", { weekday: "short" });
};

export const initials = (name = "") =>
  name.split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();

export const statusLabel = (s) => ({
  nuevo: "Nueva",
  recurrente: "Recurrente",
  vip: "VIP",
  inactivo: "Inactiva",
}[s] || s);

export const statusTone = (s) => ({
  vip: "bg-[#D6B36A] text-[#1A1A1A] border-transparent",
  recurrente: "bg-[#1A1A1A] text-[#FBF6F2] border-transparent",
  nuevo: "bg-[#FBF6F2] text-[#1A1A1A] border-[#1A1A1A]",
  inactivo: "bg-[#E8DFD1] text-[#4A4A4A] border-transparent",
}[s] || "bg-white text-[#1A1A1A] border-[#E8DFD1]");

export const apptStatusTone = (s) => ({
  confirmada: "bg-[#1A1A1A] text-[#FBF6F2]",
  pendiente: "bg-[#E8DFD1] text-[#1A1A1A]",
  completada: "bg-[#D6B36A] text-[#1A1A1A]",
  cancelada: "bg-white text-[#4A4A4A] border border-[#E8DFD1]",
}[s] || "bg-white text-[#1A1A1A]");
